// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".0ce751d09fa665f95901089f744092aa789e06c6.chunk.js";
};